import { render } from "./Chatroom.vue?vue&type=template&id=762785a0&scoped=true"
import script from "./Chatroom.vue?vue&type=script&lang=js"
export * from "./Chatroom.vue?vue&type=script&lang=js"

import "./Chatroom.vue?vue&type=style&index=0&id=762785a0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-762785a0"

export default script